import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import {toast} from "react-toastify";
import {toggleChangePassword, toggleLoader} from "../shared/actions/setting";
import FormHandler from "../shared/util/form-handler";
import {getUsername} from "../shared/authentication/authentication";
import {validateChangePassword} from "./form-validation-rules";

const ChangePassword = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [formErr, setFormErr] = useState("");
    const [showText,setShowText] = useState(false);

    const isChangePasswordVisible = useSelector(state => {
        return state.setting.isChangePasswordVisible
    });

    function hideChangePassword() {
        dispatch(toggleChangePassword(false));
    }

    const {
        values,
        errors,
        handleSubmit,
        handleChange,
        handleOnBlur,
        initForm,
    } = FormHandler(changePassword, validateChangePassword);

    function changePassword() {
        setIsLoading(true);
    }

    useEffect(() => {
        if (!isLoading) {
            return;
        }
        dispatch(toggleLoader(true));
        values.username = getUsername();
        axios.post(process.env.REACT_APP_HOST + '/change-password', values)
            .then(res => {
                if (res.status === 200) {
                    resetForm();
                    toast.success("Password changed successfully");
                }
            })
            .catch(error => {
                if (error.response.status === 422) {
                    setFormErr(error.response.data.message);
                }
            })
            .finally(() => {
                setIsLoading(false);
                dispatch(toggleLoader(false));
            })
    }, [isLoading]);

    function resetForm() {
        hideChangePassword();
        initForm({});
        setFormErr("");
        setShowText(false);
    }

    return (
        <div className={"sa-modal-bg " + (!isChangePasswordVisible && 'hide')}>
            <div className="sa-modal-bg-inner">
                <div className="sa-modal-box">
                    <div className="container">
                        <form onSubmit={handleSubmit}>
                            <div className="sa-modal-header">
                                Change Password
                                <div className="sa-modal-close" onClick={resetForm}><FeatherIcon className={"icon-in-close"} icon={"x"}/></div>
                            </div>
                            <div className="row sa-modal-content">
                                <div className="col-md-6">
                                    <div className="form-group m-b-16">
                                        <label htmlFor="email">Current Password</label>
                                        <input type={!showText ? "password" : "text"}
                                               className={`form-control ${errors.oldPassword && "warning-input"}`}
                                               onBlur={handleOnBlur} onChange={handleChange}
                                               value={values.oldPassword || ''} name="oldPassword"
                                               placeholder="Enter your current password"/>
                                        <span className="field-icon" onClick={() => setShowText(!showText)}><FeatherIcon
                                            className="toggle-password" icon={showText ? "eye-off" : "eye"}/></span>
                                        {errors.oldPassword && (
                                            <p className="warning-input-msg ">{errors.oldPassword}</p>)}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group m-b-16">
                                        <label htmlFor="email">New Password</label>
                                        <input type={!showText ? "password" : "text"}
                                               className={`form-control ${errors.password && "warning-input"}`}
                                               onBlur={handleOnBlur} onChange={handleChange}
                                               value={values.password || ''} name="password"
                                               placeholder="Enter your new password"/>
                                        <span className="field-icon" onClick={() => setShowText(!showText)}><FeatherIcon
                                            className="toggle-password" icon={showText ? "eye-off" : "eye"}/></span>
                                        {errors.password && (<p className="warning-input-msg ">{errors.password}</p>)}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group m-b-16">
                                        <label htmlFor="email">Confirm New Password</label>
                                        <input type={!showText ? "password" : "text"}
                                               className={`form-control ${errors.confirmPassword && "warning-input"}`}
                                               onBlur={handleOnBlur} onChange={handleChange}
                                               value={values.confirmPassword || ''} name="confirmPassword"
                                               placeholder="Retype your new password"/>
                                        <span className="field-icon" onClick={() => setShowText(!showText)}><FeatherIcon
                                            className="toggle-password" icon={showText ? "eye-off" : "eye"}/></span>
                                        {errors.confirmPassword && (
                                            <p className="warning-input-msg ">{errors.confirmPassword}</p>)}
                                    </div>
                                </div>
                            </div>
                            {formErr && (<div className={"login-warning-msg"}>{formErr}</div>)}
                            <div className="sa-modal-footer">
                                <div className="sa-modal-footer-btn">
                                    <button className="btn btn-sa-text w-120p" type="button"
                                            onClick={resetForm}>CANCEL
                                    </button>
                                    <button className="btn btn-sa-primary w-120p">Change</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
};

export default ChangePassword
